import React, { Component } from 'react';
import _ from 'lodash';
import './OneTimeText.css';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { campaignTypes } from '../../constants/campaign';
import ConfirmationModal from '../../components/ConfirmationModal';
import Header from '../../components/Header';
import campaignTable from '../../tables/campaigns';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import formHelpers from '../../helpers/FormHelpers';
import Guide from '../../components/Guide';
import Step from '../../components/Step';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';
import phase1Fields from '../../forms/campaign/createPhase1';
import phase2Fields from '../../forms/campaign/createPhase2';
import phase3Fields from '../../forms/campaign/createPhase3';
import phase4Fields from '../../forms/campaign/createPhase4';
import promotionHelpers from '../../helpers/promotions/buildValues';
import campaignHelpers from '../../helpers/campaign/buildValues';
import { validatePhases, checkForErrors } from '../../helpers/Validation';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import CampaignInfo from '../../helpers/CampaignInfo';
import campaignActions from '../../actions/campaign';
import messageActions from '../../actions/message';
import modalActions from '../../actions/modal';
import populateForm from '../../helpers/PopulateForm';
import promotionActions from '../../actions/promotion';
import phaseHelpers from '../../helpers/PhaseHelpers';

class OneTimeText extends Component {
	constructor() {
		super();
		this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.performCreateOrUpdate = this.performCreateOrUpdate.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleMultiSelectClick = this.handleMultiSelectClick.bind(this);
    this.handleModalCloseClick = this.handleModalCloseClick.bind(this);
		this.handleEditClick = this.handleEditClick.bind(this);
		this.resetCampaign = this.resetCampaign.bind(this);
		this.handleRowPreCheck = this.handleRowPreCheck.bind(this);
	}

	componentWillMount() {
		const { adminRole, location, dispatch, vendor } = this.props;
	
    if (vendor.selected && vendor.selected.apikey &&
      location.selected && location.selected.apikey) {
			dispatch(campaignActions.list(vendor.selected.apikey, location.selected.apikey));
		}

		if (adminRole === 'super') {
			dispatch(campaignActions.listManualQueries());
		}

    this.setState({
			showConfirmModal: false,
      activeSection: '1',
      duplicateCampaign: false,
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      phase1Fields,
      phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields,
      phase4Fields,
      updateField: false,
			modalInfo: CampaignInfo,
			modalFooterMessage: null
    })
	}

	resetCampaign() {
		const { location } = this.props;

		phase1Fields.date_from.value = moment().format('MM/DD/YY');
		phase1Fields.start_time.value = '';

    this.setState({
      duplicateCampaign: false,
      updateField: false,
      phase1Fields,
    	phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields,
			phase4Fields,
			modalFooterMessage: null
    })
	}

  performCreateOrUpdate(currentPhase) {
    const { phase1Fields, phase2Fields, phase3Fields, updateField, manualQuerySelected } = this.state;
		const { dispatch, vendor, location, manualQueries } = this.props;
    let campaignData = extractPhasesOrFail({ phase1Fields, phase2Fields });
		let promotionData = extractPhasesOrFail({ phase3Fields });
		let locationApikey = location.selected.apikey;

		let manual_query_apikey;
		if (_.isNumber(manualQuerySelected) && manualQueries.length > 0) {
			manual_query_apikey = manualQueries[manualQuerySelected].api_key;
		}

		campaignData.manual_query_apikey = manual_query_apikey;

		let campaignDataPrep = campaignHelpers.prepForPush(campaignData);

		if (campaignDataPrep.campaign_type === 'location') {
      locationApikey = campaignDataPrep.location_apikeys[0];
		}

		if (!campaignData.is_coupon) {
			promotionData = false;
		}

    if (campaignData && updateField) {
			delete campaignData.campaign_type;
			// Run for update
			if (promotionData && campaignData.is_coupon) {
				dispatch(campaignActions.update(
					campaignDataPrep,
					promotionHelpers.prepCampaignForPush(promotionData),
					vendor.selected.apikey,
					locationApikey,
					updateField.apikey,
					updateField.promotion_apikey
				));
			} else {
				dispatch(campaignActions.updateWithoutPromo(
					campaignDataPrep,
					vendor.selected.apikey,
					locationApikey,
					updateField.apikey,
					updateField.promotion_apikey
				));
			}
			this.resetCampaign();
		} else if (campaignData && promotionData && campaignData.is_coupon) {
			// Run for duplicate or create with promotionData
			let promotion_data = promotionHelpers.prepCampaignForPush(promotionData)
			if (campaignData.is_offer) {
				promotion_data = promotionHelpers.prepClaimForPush(promotionData);
			}

			const { duplicateCampaign } = this.state;
			if (duplicateCampaign) {
				campaignDataPrep.campaign_type = duplicateCampaign.campaign_type;
				if(duplicateCampaign.campaign_type === campaignTypes.CUSTOM) {
					campaignDataPrep.manual_query_apikey = duplicateCampaign.manual_apikey;
				}

			}

    	dispatch(campaignActions.create(
				campaignDataPrep,
				promotion_data,
				vendor.selected.apikey,
				locationApikey
			));
			this.resetCampaign();
    } else if (campaignData && !promotionData) {
			const { duplicateCampaign } = this.state;
			if (duplicateCampaign) {
				campaignDataPrep.campaign_type = duplicateCampaign.campaign_type;
				if(duplicateCampaign.campaign_type === campaignTypes.CUSTOM) {
					campaignDataPrep.manual_query_apikey = duplicateCampaign.manual_apikey;
				}

			}

			dispatch(campaignActions.createWithoutPromo(
				campaignDataPrep,
				vendor.selected.apikey,
				locationApikey
			));
			this.resetCampaign();
		} else {
      new Promise((resolve, reject) => {
        this.setState({
          [currentPhase]: formHelpers.blurphase(this.state[currentPhase])
        })
        resolve();
      }).then(() => {
        if (checkForErrors(this.state[currentPhase]) === false) {
          if (nextSection === '4') buttonNext = 'Finish';
          this.setState({
            activeSection: nextSection,
            buttonText: buttonNext,
            currentPhase: nextPhase
          })
        } else {
          this.setState({
            [currentPhase]: validatePhases(this.state[currentPhase])
          })
        }
      })
    }
  }

	handleNextClick() {
		const { activeSection, currentPhase } = this.state;
		if (this.state.phase1Fields.is_coupon.value) {
			phaseHelpers.handleNextClick(activeSection, currentPhase, '5', this);
		} else {
			phaseHelpers.handleNextClick(activeSection, currentPhase, '4', this);
		}
	}

	handleBackClick = () => {
		const { activeSection, currentPhase } = this.state;
		phaseHelpers.handleBackClick(activeSection, currentPhase, this);
	}

	handleSelectFieldChange(option, name) {
		formHelpers.handleSelectFieldChange(option, name, this.state.currentPhase, this);
	}

	handleMultiSelectClick(name, index, value) {
		if (name === 'locations') {
			this.setState({
				manualQuerySelected: null
			});
		}
		formHelpers.handleMultiSelectClick(name, index, value, this.state.currentPhase, this);
	}

  handleCheckboxClick(name, value) {
    formHelpers.handleCheckboxClick(value, name, this.state.currentPhase, this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, this.state.currentPhase, this);
  }

  handleSelectClick(field) {
    formHelpers.handleSelectClick(field, this.state.currentPhase, this)
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, this.state.currentPhase, this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, this.state.currentPhase, this);
  }

	handleModalToggle() {
    const { dispatch, modal } = this.props;
    dispatch(modalActions.modalToggle(!modal.showModal));
	}

	handleModalCloseClick() {
		this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
			buttonText: 'next',
			manualQuerySelected: null
		})
		this.handleModalToggle();
		this.resetCampaign();
	}

  handleNewClick() {
		const { dispatch, location } = this.props;

		if (!location.selected) {
			dispatch(messageActions.setErrorMessage('Please select a location in the sidebar to create a campaign.'));
			return;
		}

    this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      phase1Fields: JSON.parse(JSON.stringify(this.state.phase1Fields)),
      phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields: JSON.parse(JSON.stringify(phase3Fields)),
			phase4Fields: JSON.parse(JSON.stringify(phase4Fields)),
			modalFooterMessage: null
    });
    this.handleModalToggle();
  }

	handleEditClick(campaign, isDuplicate=false) {
		const {adminRole, manualQueries, dispatch, vendor, location } = this.props;
		phase1Fields.date_from.value = moment(campaign.delivery_date).format('MM/DD/YY');
		phase1Fields.start_time.value = moment(campaign.delivery_date, 'YYYY-MM-DDTHH:mm:ss.sssZZ').format('YYYY-MM-DD HH:mm:ss');
		let updateFieldValue = _.cloneDeep(campaign);
		if (isDuplicate) {
			updateFieldValue = false;
		};

		this.setState({
			modalFooterMessage: isDuplicate ? 'You are duplicating this campaign to create a new similar campaign.' : 'You are editing this campaign.'
		});

		let manualQuerySelected;
		if (campaign.manual_apikey && adminRole === 'super' && manualQueries.length > 0) {
			_.forEach(manualQueries, (query, index) => {
				if (query.api_key === campaign.manual_apikey) {
					manualQuerySelected = index;
				}
			});
		}

		if (campaign.promotion_apikey !== '') {
			new Promise((resolve, reject) => {
				dispatch(modalActions.modalToggle(true));
				dispatch(promotionActions.retrieve(
					vendor.selected.apikey, location.selected.apikey, campaign.promotion_apikey, resolve));
			}).then((res) => {
				this.setState({
          activeSection: '1',
          currentPhase: 'phase1Fields',
          buttonText: 'Next',
          updateField: updateFieldValue,
          updatePromotion: res,
          phase1Fields: populateForm(campaignHelpers.buildPhase1(campaign), phase1Fields),
          phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data, campaign.location_apikeys),
          phase3Fields: populateForm(res, phase3Fields),
					phase4Fields: populateForm(campaign, phase4Fields),
					manualQuerySelected 
        });
			})
		} else {
			const campaignCopy = _.clone(campaign);

			dispatch(modalActions.modalToggle(true));
			campaignCopy.is_coupon = false;

			this.setState({
				activeSection: '1',
				currentPhase: 'phase1Fields',
				buttonText: 'Next',
				updateField: updateFieldValue,
				phase1Fields: populateForm(campaignHelpers.buildPhase1(campaignCopy), phase1Fields),
				phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data, campaignCopy.location_apikeys),
				phase3Fields,
				phase4Fields: populateForm(campaignCopy, phase4Fields),
				manualQuerySelected
			});
		}
	}

	closeConfirmModal = () => {
		this.setState({
			cancelCampaign: null,
			showConfirmModal: !this.state.showConfirmModal
		});
	}

	handleCancelClick = (campaign) => {
		this.setState({
			cancelCampaign: campaign,
			showConfirmModal: true
		});
	}

	handleCancelCampaign = async () => {
		const { dispatch, location } = this.props;
		const { cancelCampaign } = this.state;
		await dispatch(campaignActions.destroy(location.selected.apikey, location.selected.vendor_apikey, cancelCampaign.apikey));
		this.closeConfirmModal();
	}

	handleDuplicateClick = (campaign) => {
		this.setState({
			duplicateCampaign: _.cloneDeep(campaign)
		}, () => {
			this.handleEditClick(campaign, true);
		});
	}

	handleRowPreCheck(column) {
		return _.isEmpty(column.recurring_type);
	}

	renderSelectedLocation(locations) {
		const {manualQueries} = this.props;
		const {manualQuerySelected, updateField, duplicateCampaign} = this.state;

		const selectedLocations = _.filter(locations, (location) => {
			if (location.value) return location;
		});

		const isManualQuery = () => {
			return _.isNumber(manualQuerySelected) || _.get(updateField, 'campaign_type') === 'custom' || _.get(duplicateCampaign, 'campaign_type') === 'custom';
		};

		if(isManualQuery()) return _.get(manualQueries, `[${manualQuerySelected}].title`, 'Manual Query');

		if(selectedLocations.length === locations.length) return 'Everyone';

		return selectedLocations.map((location, idx) =>
			<span key={`location-${idx}`}>
				{location.name}{idx !== selectedLocations.length - 1 ?  ', ' : null}
			</span>
		);
	}

	handleQueryClick = (selectedQuery) => {
		const {location} = this.props;
		
		const queryToSave = selectedQuery === this.state.manualQuerySelected ? null : selectedQuery;

		this.setState({
			manualQuerySelected: queryToSave,
			phase2Fields: campaignHelpers.addLocationsToMulti(phase2Fields, location.data),
		})
	}

	renderManualQueriesOptions = () => {
		const {adminRole, manualQueries} = this.props;
		const {updateField, duplicateCampaign} = this.state;

		if (adminRole !== 'super') {
			// Use the manual query title in this block when it is available so that we can show the query name to the non-super user.

			if((_.get(updateField, 'campaign_type') === 'custom') || (_.get(duplicateCampaign, 'campaign_type') === 'custom')) {
				return (
					<div className="input-field-wrap">
						<h2 className="multiselect__title">Manual Queries</h2>
						<p className="campaign-text__placeholder">This is a custom campaign. You cannot change the campaign query when editing or duplicating a custom campaign.</p>
					</div>
				)
			}

			return null;
		}
		if (adminRole === 'super' && _.size(manualQueries) === 0) return(
			<div className="input-field-wrap">
				<h2 className="multiselect__title">Manual Queries</h2>
				<p className="campaign-text__placeholder">No Queries available</p>
			</div>
		);

		let queryFields = manualQueries.map((query, index) => ({
			name: index,
			placeholder: query.title,
			value: this.state.manualQuerySelected === index ? true : false
		}));

		return (
			<div className="input-field-wrap">
				<h2 className="multiselect__title">Manual Queries</h2>
				<div className="multiselect">
					{ queryFields.map((query, index) => {
						return (
							<Checkbox
								key={index}
								field={query}
								handleClick={this.handleQueryClick}/>
						);
					}) }
				</div>
			</div>
		)
	}

	renderLocationFields = () => {
		const {updateField, duplicateCampaign, phase2Fields} = this.state;

		if((_.get(updateField, 'campaign_type') === 'custom') || (_.get(duplicateCampaign, 'campaign_type') === 'custom')) {
			return null;
		}

		return formHelpers.buildFields(phase2Fields, this);
	}

	renderModal = () => {
		const { activeSection, modalInfo, phase1Fields, phase2Fields, phase3Fields } = this.state;

		return(
			<Modal
				handleCloseClick={this.handleModalCloseClick}
				title={modalInfo[parseInt(activeSection, 10) - 1].title}
				footerMessage={this.state.modalFooterMessage}>
				<div className="signup__guide">
					<Guide
						header={modalInfo[parseInt(activeSection, 10) - 1].subTitle}
						message={modalInfo[parseInt(activeSection, 10) - 1].content}
						/>
				</div>
				
				<div className="signup__form campaign__form">
					<div className="full-wrap">
						<div className="step__wrap">
							<Step text="1" isActive={activeSection === '1' ? true : false} />
							<Step text="2" isActive={activeSection === '2' ? true : false} />
							{this.state.phase1Fields.is_coupon.value &&
								<Step text="3" isActive={activeSection === '3' ? true : false} />
							}
							{this.state.phase1Fields.is_coupon.value &&
								<Step text="4" isActive={activeSection === '4' ? true : false} />
							}
							{!this.state.phase1Fields.is_coupon.value &&
								<Step text="3" isActive={activeSection === '3' ? true : false} />
							}
						</div>
					</div>
					<div className="campaign__form__wrapper">
						{
							activeSection === '1' &&
							<div>
								{ formHelpers.buildFields(phase1Fields, this) }
							</div>
						}
						{
							activeSection === '2' &&
							<div>
								{ this.renderLocationFields() }
								{ this.renderManualQueriesOptions() }
							</div>
						}
						{
							activeSection === '3' && this.state.phase1Fields.is_coupon.value &&
							<div>
								{ formHelpers.buildFields(phase3Fields, this) }
							</div>
						}
						{
							(activeSection === '4' || (activeSection === '3' && !this.state.phase1Fields.is_coupon.value)) &&
							<div>
								<h3 className="campaign-text__label">Text Message</h3>
								<div className="campaign-text__message">
									<p className="campaign-text__message-text">{phase1Fields.body.value}</p>
								</div>
								<div className="clear"></div>
								<p className="campaign-text__label campaign-text__label--wide">{phase1Fields.body.value.length} Characters = <span className="campaign-text__blue">1 Message Per Customer</span></p>
								<div className="clear"></div>
								{this.state.phase1Fields.is_coupon.value &&
									<div>
										<p className="campaign-text__label">Offer Name:</p>
										<p className="campaign-text__value">{this.state.phase3Fields.name.value}</p>
									</div>
								}
								<p className="campaign-text__label">Being sent on:</p>
								<p className="campaign-text__value">{`${moment(phase1Fields.date_from.value).format('MMM Do YYYY')} ${moment(phase1Fields.start_time.value).format('h:mm a')}`}</p>
								<div className="clear"></div>
								<p className="campaign-text__label">Sending it to:</p>
								<p className="campaign-text__value">{this.renderSelectedLocation(_.get(phase2Fields, 'locations.value', []))}</p>
								{ formHelpers.buildFields(this.state.phase4Fields, this) }
								<div className="clear"></div>
							</div>
						}
					</div>

					<div className="campaign__actions">
						{this.state.activeSection !== '1' &&
							<div className="campaign-text__button-wrap">
								<Button
									allowHover={true}
									text='Back'
									onClick={this.handleBackClick}/>
							</div>
						}
						<Button
							allowHover={true}
							success={true}
							text={this.state.buttonText}
							onClick={this.handleNextClick}/>
					</div>
				</div>
			</Modal>
		);
	}

  render() {
    return (
      <div>
				<Header
					handlePrimaryClick={this.handleNewClick}
          handleLogout={this.props.handleLogoutClick}
					primaryText="NEW CAMPAIGN"
					title="ONE TIME TEXT CAMPAIGN" />
				<Table
					handleCancelClick={this.handleCancelClick}
					handleDuplicateClick={this.handleDuplicateClick}
					handleEditClick={this.handleEditClick}
					rowPreCheck={this.handleRowPreCheck}
					rows={this.props.campaign.data}
					columns={campaignTable} />
				{ this.state.showConfirmModal &&
					<ConfirmationModal
						message="Are you sure you want to cancel this campaign? This action cannot be undone."
						onCancel={this.closeConfirmModal}
						onConfirm={this.handleCancelCampaign} />
				}
				{ this.props.modal.showModal && this.renderModal() }
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
		adminRole: _.get(state, 'admin.data.role', null),
    campaign: state.campaign,
		location: state.location,
		vendor: state.vendor,
		manualQueries: _.get(state, 'campaign.manualQueries'),
		modal: state.modal,
		promotion: state.promotion
  })
)(OneTimeText));



/** WEBPACK FOOTER **
 ** ./src/containers/OneTimeText/index.js
 **/